import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { basename } from 'src/utilities/urlUtility';
import { ProgramCardProvider } from 'src/remotes/ProgramCardProvider';
import { MemberExperienceUserFromIdToken } from '@guildeducationinc/auth-frontend-tools';
import { getUserValuesForPath } from '@src/constants/getUserValuesForPath';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { OptimizelyProvider } from './OptimizelyProvider';

// This component is rendered within an Algolia autocomplete panel that exists outside the normal React hierarchy,
// so it cannot access context. Instead, pass values in as props (auth values are handled this way) or add the necessary providers here.

interface AutocompleteProvidersProps {
	children: React.ReactNode;
	authUser?: MemberExperienceUserFromIdToken;
	getAccessToken: () => Promise<string | undefined>;
	getIdToken: () => Promise<string | undefined>;
	programUuids?: string[];
}

export const AutocompleteProviders: React.FC<AutocompleteProvidersProps> = ({
	children,
	authUser,
	getAccessToken,
	getIdToken,
	programUuids,
}) => {
	const user = getUserValuesForPath(authUser);

	return (
		<ErrorBoundary>
			<BrowserRouter basename={basename}>
				<OptimizelyProvider user={authUser}>
					<ProgramCardProvider
						getAccessToken={getAccessToken}
						getIdToken={getIdToken}
						programUuids={programUuids}
						user={user}
					>
						{children}
					</ProgramCardProvider>
				</OptimizelyProvider>
			</BrowserRouter>
		</ErrorBoundary>
	);
};
